export default "__VITE_ASSET__CqO8jtK2__"